<cfp-modal-content [title]="'buildingCode.modal.title'" (closeClicked)="hide()">
  <ng-container modal-body>
    <p>{{ 'buildingCode.modal.body' | cfpTranslate }}</p>
    @let formGroupValue = formGroup();
    @if (formGroupValue) {
      <form [formGroup]="formGroupValue" id="buildingCodeForm" (ngSubmit)="save()">
        <cfp-form-group [label]="'buildingCode'" [classes]="'mb-0'">
          <cfp-input-text formControlName="code" />
        </cfp-form-group>
      </form>
    } @else {
      <cfp-loading-spinner [loading]="true" />
    }
  </ng-container>
  <cfp-button-loading modal-footer [loading]="saving()" [buttonType]="'submit'" [buttonForm]="'buildingCodeForm'">
    {{ 'save.button' | cfpTranslate }}
  </cfp-button-loading>
</cfp-modal-content>
